// @vendors
import { put, takeLatest } from 'redux-saga/effects';

// @Actions
import {
  REQUEST_FAILURE
} from './app.actionTypes';

// @Utils
import { signOut } from '../../utils/auth';

import { LOGOUT_SUCCESS } from '../auth/auth.actionTypes';

function* failureWorker({ payload }) {
  if (payload.statusError === 401) {
    signOut();
    yield put({ type: LOGOUT_SUCCESS });
  }
}

function* requestWatcher() {
   yield takeLatest(REQUEST_FAILURE, failureWorker);
}

export default { requestWatcher };



// WEBPACK FOOTER //
// ./src/state/app/app.sagas.js